import React, { useState, useEffect } from "react";
import Dropdown from "./Dropdown";
import PlayerStatsInnerWrp from "./PlayerStatsInnerWrp";
import { loadStyles } from "../../../utils/cssLoader";
const TeamPlayerStatsWrp = ({
  data,
  teamId,
  baseUrl,
  dataClient,
  loadCSS,
  title,
  websiteBaseUrl,
  dataPath,
}) => {
  const [clientData, setClientData] = useState([]);
  const [teamData, setTeamData] = useState(dataClient ? clientData : data);
  const [leagueSelectedId, setLeagueSelectedId] = useState(
    dataClient ? clientData?.league?.data?.[0]?.id : data?.league?.data?.[0]?.id
  );

  const items = dataClient ? clientData?.league : data?.league;
  useEffect(() => {
    if (!dataClient) return;

    const container = document.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed || []);
      setTeamData(parsed?.squad);
      setLeagueSelectedId(parsed?.league?.data?.[0]?.id);
    } catch (error) {
      console.error("Failed to parse client data:", error);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("team");
    }
  }, [loadCSS]);

  useEffect(() => {
    if (!leagueSelectedId || !teamId) return;

    const fetchTableData = async () => {
      try {
        const res = await fetch(
          `${baseUrl}/football/stat/team/${teamId}/player-stats?leagueId=${leagueSelectedId}`,
          {
            headers: {
              Token: process.env.REACT_APP_API_TOKEN,
            },
          }
        );
        if (!res.ok) throw new Error(res.statusText);

        const json = await res.json();
        setTeamData(json || []);
      } catch (err) {
        console.error("Failed to fetch squad:", err);
      }
    };

    fetchTableData();
  }, [leagueSelectedId, teamId]);

  return (
    <>
      {title && <h1>{title}</h1>}

      <Dropdown
        items={items?.data}
        defaultValue={leagueSelectedId}
        setLeagueSelectedId={setLeagueSelectedId}
      />
      <PlayerStatsInnerWrp
        data={teamData?.data}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        dataClient={dataClient}
      />
    </>
  );
};

export default TeamPlayerStatsWrp;
